import { Box } from "@mantine/core";
import clsx from "clsx";
import { useCallback, useMemo } from "react";

import { useUserContext } from "@/features/auth/contexts/useUserContext";
import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import { useSignInReminder } from "@/features/user/hooks/useSignInReminder";
import {
  ModelOrderByWithRelationInput,
  ModelWhereInput,
} from "@/generated/graphql-hooks";
import CrossIcon from "@/icons/cross.svg";
import SaveModelIcon from "@/icons/save_model.svg";

export const SaveModelFilter = () => {
  const {
    query: { where },
    setWhere,
  } = useRequestQuery<ModelWhereInput, ModelOrderByWithRelationInput>();
  const { user } = useUserContext();
  const { signInReminderFunctionWrapper } = useSignInReminder();

  const isFilterSet = useMemo(() => {
    return !!where.usersSaved;
  }, [where]);

  const toggleFilter = useCallback(() => {
    const { usersSaved, ...rest } = where;

    if (isFilterSet) {
      setWhere(rest);
      return;
    }

    setWhere({
      ...rest,
      usersSaved: {
        some: {
          userId: {
            equals: user.id,
          },
        },
      },
    });
  }, [user, where, setWhere, isFilterSet]);

  return (
    <Box
      className={clsx(
        "flex h-full cursor-pointer items-center gap-1 rounded-full border bg-white px-4 py-2",
        isFilterSet
          ? "text-primary border-primary"
          : "border-gray-400 text-gray-500",
      )}
      onClick={signInReminderFunctionWrapper(toggleFilter)}
    >
      {isFilterSet ? (
        <CrossIcon className="text-primary h-4 w-4" />
      ) : (
        <SaveModelIcon className="h-4 w-4 text-gray-500" />
      )}
      <span className="font-light">我的收藏</span>
    </Box>
  );
};
